import { useHomeContext } from "@/context/homeContext";
import Image from "next/image";
import React from "react";

const GuestTitle = ({ toggleGuest }) => {
  const { filterForm } = useHomeContext();
  return (
    <div
      onClick={toggleGuest}
      className="relative flex flex-col items-start gap-1 px-4 py-1.5 lg:border-r cursor-pointer lg:border-[#ECEFF5]"
    >
      <span className="text-[#9DADC0] text-xs font-medium leading-normal tracking-[1.8px]">
        MİSAFİR
      </span>
      <div className="flex items-center justify-between w-full">
        <span className="text-sm font-medium leading-normal tracking-tight text-themeBlack">
          {`${filterForm.yetiskin} Yetiskin, ${filterForm.cocuk} Çocuk`}
        </span>
        <Image src={"/icons/down.svg"} width={12} height={12} alt="icon" />
      </div>
    </div>
  );
};

export default GuestTitle;
